/**
 * Acceso de LECTURA a proveedores en el FE — espejo de la regla del backend.
 *
 * ⚠️ MIRROR MANUAL de `verix-api/src/utils/permissionSets.ts` (repos distintos, NO
 * compartible). MANTENER EN SYNC: si en el backend cambian SUPPLIER_READ_PERMISSIONS
 * o SUPPLIER_WRITE_ROLES (gate de `GET /api/suppliers` + fuente supplier de
 * `/api/contact-directory`), actualizar también aquí.
 *
 * Regla combinada: lee proveedores quien esté en los writeRoles (incl. el rol legacy
 * `manager`, que el backend deja leer aunque no tenga permisos sembrados) O tenga
 * ALGUNO de los permisos de dominio que usan proveedores. admin/owner ∈ writeRoles.
 */
import { useApp } from '@/components/hooks/useApp';

export const SUPPLIER_READ_PERMISSIONS = ['accounting.view', 'expenses.view', 'invoicing.view', 'inventory.view'];
export const SUPPLIER_WRITE_ROLES = ['admin', 'owner', 'manager', 'accountant'];

/** Pura — refleja el gate de lectura del backend. */
export function canReadSuppliers({ role, permissions = [] } = {}) {
  return SUPPLIER_WRITE_ROLES.includes(role)
    || SUPPLIER_READ_PERMISSIONS.some((p) => permissions.includes(p));
}

/**
 * Hook de acceso. `isLoading` trata el `user` aún no cargado como loading: si no, el
 * guard evaluaría role/permissions vacíos → false → redirigiría a `/` a un usuario
 * autorizado (flash-of-redirect). Solo se decide allowed/denegado con el user cargado.
 */
export function useCanReadSuppliers() {
  const { user, loading } = useApp();
  const isLoading = loading || user === undefined;
  const allowed = canReadSuppliers({ role: user?.role, permissions: user?.permissions });
  return { allowed, isLoading };
}
